export default (params) => ({
  trigger: {
    name: 'product_specifications.select_item_in_composed',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      method: {
        enum: [
          'title',
          'image',
        ],
      },
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'select_item',
      params: {
        sub_feature: 'composed_content',
      },
    },
  },
});
